import { uiText, useUiLanguage } from '@/i18n/interface';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Plus, Send, Users, MessageSquare, HelpCircle } from 'lucide-react';
import WarriorAI from '../chat/WarriorAI';
import SupportRequestDialog from './SupportRequestDialog';
import SupportRequestStatus from './SupportRequestStatus';

interface Props { onNewSession: () => void; onSendNotifications: () => void; onViewStudents: () => void; }
export default function AdminQuickActions({ onNewSession, onSendNotifications, onViewStudents }: Props) {
  useUiLanguage();
  const { t } = useTranslation('admin');
  const [supportDialogOpen, setSupportDialogOpen] = useState(false);
  const [supportStatusOpen, setSupportStatusOpen] = useState(false);
  const actions = [
    { key: 'quickActions.scheduleNewSession', text: uiText("Schedule session"), icon: Plus, onClick: onNewSession },
    { key: 'quickActions.sendNotifications', text: uiText("Send notification"), icon: Send, onClick: onSendNotifications },
    { key: 'quickActions.viewAllStudents', text: uiText("View students"), icon: Users, onClick: onViewStudents },
    { key: 'support.requestSupport', text: uiText("Request support"), icon: HelpCircle, onClick: () => setSupportDialogOpen(true) },
    { key: 'studio.supportStatus', text: uiText("Support status"), icon: MessageSquare, onClick: () => setSupportStatusOpen(true) },
  ];
  return <Card><CardHeader><CardTitle>{t("admin:quickActions.title", { defaultValue: 'Quick actions' })}</CardTitle></CardHeader><CardContent className="space-y-5">
    <div className="flex flex-wrap gap-2">{actions.map((a,i)=><Button key={a.key} variant={i===0?'default':'outline'} onClick={a.onClick} className="max-w-full whitespace-normal text-left"><a.icon className="h-4 w-4" />{t(a.key,{defaultValue:a.text})}</Button>)}</div>
    <WarriorAI />
    <SupportRequestDialog open={supportDialogOpen} onOpenChange={setSupportDialogOpen} />
    <SupportRequestStatus open={supportStatusOpen} onOpenChange={setSupportStatusOpen} />
  </CardContent></Card>;
}
